export function paramCase(str: string) {
  return str
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');
}

export function snakeCase(str: string) {
  return str
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '');
}

export function titleCase(input: unknown, locale = "fr-FR"): string {
  const s = String(input ?? "").toLocaleLowerCase(locale);
  // Majuscule sur la première lettre après début ou caractère non-lettre (Unicode)
  return s.replace(
    /(^|[^\p{L}\p{M}])(\p{L})/gu,
    (_m, prefix: string, ch: string) => prefix + ch.toLocaleUpperCase(locale)
  );
}

